import React from "react";
import { Routes, Route } from "react-router-dom";
import routes from "../routes";
import AuthGuard from "../components/AuthGuard";

const Auth: React.FC = () => {
  return (
    <div className="auth-layout">
      <AuthGuard>
        <Routes>
          {routes.map((prop, key) => {
            if (prop.layout === "/auth") {
              return (
                <Route
                  path={prop.path}
                  element={prop.component}
                  key={key}
                />
              );
            }
            return null;
          })}
        </Routes>
      </AuthGuard>
    </div>
  );
};

export default Auth; 